






































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ResepItemInput from "@/components/pemeriksaan/resep-obat/ResepItemInput.vue";
import CardListResep from "./resep-obat/CardListResep.vue";
import { resepStore } from "@/store/modules/resep";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import ResepObatSvc from "@/services/ResepObat";
import OrderResepList from "@/components/pemeriksaan/resep-obat/OrderResepList.vue";
import { refResepStore as refStore } from "@/store/modules/ReferensiResep";
import OrderBmhpList from "./resep-obat/OrderBmhpList.vue";
import { orderBmhpStore } from "@/store/modules/OrderBmhp";
import PaketObatList from "./resep-obat/lembar-permintaan/PaketObat/PaketObatList.vue";
import AntimikrobaReserveList from "./resep-obat/lembar-permintaan/AntimikrobaReserve/AntimikrobaReserveList.vue";
import ReturObatList from "@/components/ReturObat/ReturObatList.vue";
import OrderEmergensiList from "./resep-obat/order-emergensi/OrderEmergensiList.vue";
import { gabungRacikanKeItems } from "@/utils/gabungRacikanResep";

@Component({
  components: {
    ResepItemInput,
    CardListResep,
    OrderResepList,
    OrderBmhpList,
    PaketObatList,
    AntimikrobaReserveList,
    ReturObatList,
    OrderEmergensiList
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class TabResepObatRanap extends Vue {
  dataExample = "";
  listResep = [];
  activeResep = null;
  timeout = 2000;
  innerTab = "sub-resep-bmhp";
  focusOrderEmergensiId: number | null = null;

  @Prop() register: number;

  @Prop() rm: number;

  @Prop({ default: null }) deepLink!: any;

  // Deep link from the universal form search on PasienFlyingBar (guarded by topTab).
  @Watch("deepLink", { immediate: true })
  onDeepLink(payload: any) {
    if (!payload || payload.topTab !== "tab-resep" || !payload.elemId) {
      return;
    }
    this.$nextTick(() => {
      this.innerTab = payload.elemId;
    });
  }

  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  mounted() {
    this.getResepList(this.register).then(() => {
      // const userResep = resepStore.resep.filter(resep => {
      //   return resep.dokter.id == userModule.user.id;
      // });
      // if (userResep.length) {
      //   this.setActiveResep(userResep[userResep.length - 1]);
      // }
    });

    orderBmhpStore.getOrderByRegister(this.register);

    this.getReferensi();
  }

  get stateuser() {
    return userModule.user;
  }

  get loading() {
    return appModule.loading;
  }

  get mode() {
    return appModule.mode;
  }

  get snackbar() {
    return appModule.snackbar;
  }

  get notice() {
    return appModule.notice;
  }

  get editing() {
    return resepStore.inputResepMode;
  }

  updateResepList() {
    this.getResepList(this.register);
  }

  bukaOrderEmergensi(orderId: number) {
    this.innerTab = "sub-order-emergensi";
    this.focusOrderEmergensiId = null;
    this.$nextTick(() => {
      this.focusOrderEmergensiId = orderId;
    });
  }

  setActiveResep(val) {
    console.log("set active resep", val);

    this.activeResep = null;
    this.editResep(gabungRacikanKeItems(val));
  }

  getResepList(reg) {
    resepStore.SET_LIST_LOADING(true);

    return ResepObatSvc.getByRegister(reg)
      .then(response => {
        resepStore.setResep(response.data.data);
        // console.log("aaa:", response.data.data);
      })
      .then(() => {
        resepStore.SET_LIST_LOADING(false);
      });
  }

  addResep() {
    if (this.readOnly) return;
    this.editResep(null);

    console.log("sohw input resep", resepStore.inputResepMode);
  }

  editResep(val) {
    if (this.readOnly) return;
    resepStore.hideInputResep();
    this.$nextTick(() => {
      this.activeResep = val;
      resepStore.showInputResep();
    });

    setTimeout(() => {
      document
        .getElementById("resepInput")
        .scrollIntoView({ behavior: "smooth" });
    }, 200);
  }

  getReferensi() {
    if (!refStore.refRute.length) {
      refStore.getRefRute();
    }

    if (!refStore.refFrekuensi.length) {
      refStore.getRefFrekuensi();
    }

    if (!refStore.refSediaan.length) {
      refStore.getRefSediaan();
    }
  }
}
